import * as $ from 'jquery';
import * as ko from 'knockout';

declare var DobryKantor: any;
declare var Hammer: any;

export class OpinionsComponent {
    opinions: ko.ObservableArray<any>;
    index: ko.Observable<number>;
    opinion: ko.Computed<any>;
    opinion_2: ko.Computed<any>;
    opinion_3: ko.Computed<any>;
    timer: any;
    timerStopped: boolean = false;
    opinionElement: ko.Observable<HTMLElement>;

    executeTimer() {
        if (!this.timerStopped) {
            this.timer = setTimeout(() => {
                this.next(false);
                this.executeTimer();
            }, 5000);
        }
    }

    constructor() {
        this.opinionElement = ko.observable(null as HTMLElement);
        this.index = ko.observable(0);
        this.opinions = ko.observableArray([
            // {
            //     text: "Bardzo sprawna i niewiarygodnie szybka obsługa. Odpowiedzi na maile niemal natychmiastowe. Szybkie transfery gotówki. Polecam!",
            //     signature: "Gosia"
            // },
            // {
            //     text: "Ekspresowo i w najlepszej cenie! Polecam!!!",
            //     signature: "Anna"
            // },
            {
                text: "Z czystym sumieniem POLECAM! To już kolejne moje transakcje z Dobrym Kantorem i tylko się upewniam w dobrym wyborze partnera do interesów. Bez wychodzenia z domu, błyskawicznie i pewnie. Polecam wszystkim wahającym się :-)",
                signature: "Alicja"
            },
            {
                text: "To miała być moja pierwsza transakcje w kantorze internetowym. Po długim namyśle wybrałem DobryKantor.pl i jestem bardzo zadowolony. Na pochwałę zasługuje przede wszystkim czas pełnej transakcji - od momentu wykonania przelewu przeze mnie na konto Kantoru do powrotu gotówki na moje konto po wymianie minęło około 20 minut.",
                signature: "Robin"
            },
            // {
            //     text: "Szybkie transakcje w tym samym banku. W razie problemów pomocje informacje.",
            //     signature: "Beata"
            // }
            {
                text: "Świetny kantor. Szybko, łatwo i bezpiecznie wymieniam walutę już od kilku lat. Zawsze jak miałam jakieś wątpliwości lub pytania, bez problemu mogłam skontaktować się z obsługą kantoru, która za każdym razem był uprzejma i pomocna. Polecam współpracę z czystym sumieniem!",
                signature: "mki"
            },
            {
                text: "Szybka i sprawna transakcja. W przeciwieństwie do podobnych stron, kurs po przeprowadzeniu transakcji jest odrobinę korzystniejszy niż ten widniejący na stronie głównej. Duży plus za takie rozwiązanie.",
                signature: "Magda"
            },
            {
                text: "Transakcja przeprowadzona bardzo sprawnie. Firma nie pobiera prowizji od transakcji, więc koszty zakupu nie są ukryte i zgodne z podanym kursem. Podczas rozmowy otrzymałam odpowiedzi na wszystkie moje pytania.",
                signature: "Teresa"
            },
            {
                text: "Współpraca z DobryKantor.pl jest dokładnie tym, czego potrzebuję. Bez wychodzenia z domu wymieniam walutę po rewelacyjnym kursie. Wszystko oczywiście w ekspresowym tempie. Polecam na 100%!!!",
                signature: "Anna"
            },
            {
                text: "Od paru lat korzystam z usług tylko tego kantoru i to chyba najlepsza opinia, jaką mogę wystawić. Serdecznie polecam ze względu na bezpieczeństwo transakcji, szybkość transakcji oraz konkurencyjne kursy walut.",
                signature: "TomDrone"
            }
        ]);

        this.opinion = ko.computed(() => {
            return this.opinions()[this.index()];
        });

        this.opinion_2 = ko.computed(() => {
            return this.opinions()[(this.index() + 1) % this.opinions().length];
        });

        this.opinion_3 = ko.computed(() => {
            return this.opinions()[(this.index() + 2) % this.opinions().length];
        });

        this.executeTimer();

        var hammertime = new Hammer($('#co-mowia-nasi-klienci-dk').get(0), {});
        hammertime.on('swiperight', ev => {
            this.prev(true);
        });

        hammertime.on('swipeleft', ev => {
            this.next(true);
        });
    }

    prev(stopTimer: boolean) {
        this.hide();
        if (stopTimer) {
            this.timerStopped = true;
            clearTimeout(this.timer);
        }

        let newIndex = (this.index() + 1) % this.opinions().length;
        this.index(newIndex);
        this.fadeIn();
    }

    next(stopTimer: boolean) {
        this.hide();
        if (stopTimer) {
            this.timerStopped = true;
            clearTimeout(this.timer);
        }

        let newIndex = (this.index() + 1) % this.opinions().length;
        this.index(newIndex);
        this.fadeIn();
    }

    hide() {
        if (this.opinionElement() != null) {
            $(this.opinionElement()).addClass('zero-opacity').removeClass('full-opacity')
                .removeClass('fade-in-animation');
        }
    }

    fadeIn() {
        if (this.opinionElement() != null) {
            $(this.opinionElement()).delay(1)
                .addClass('fade-in-animation').addClass('full-opacity').removeClass('zero-opacity');
        }
    }
}
